import { ApiBase, HttpMethod } from "../../core/api-base";
import { z } from "zod";
import { RunJobBody, UpdateJobBody } from "../../api/generated/jobs.zod";

type RunJobPayload = z.infer<typeof RunJobBody>;
type UpdateJobPayload = z.infer<typeof UpdateJobBody>;

export class JobsDashboardApi extends ApiBase {
    public async fetchJobs(): Promise<Response> {
        return super.apiRequest("/api/v1/jobs", HttpMethod.Get, null, { noSpinner: true });
    }

    public async runJob(jobKey: string, dryRun: boolean): Promise<Response> {
        const payload: RunJobPayload = {
            dry_run: dryRun ? 1 : 0,
        };
        return super.apiRequest(`/api/v1/jobs/${encodeURIComponent(jobKey)}/run`, HttpMethod.Post, payload);
    }

    public async abortJob(jobKey: string): Promise<Response> {
        return super.apiRequest(`/api/v1/jobs/${encodeURIComponent(jobKey)}/abort`, HttpMethod.Post, null);
    }

    public async updateJob(jobKey: string, payload: UpdateJobPayload): Promise<Response> {
        return super.apiRequest(`/api/v1/jobs/${encodeURIComponent(jobKey)}`, HttpMethod.Put, payload);
    }
}
